var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-1",
    attrs: {
      "max-width": "1140px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_c('span', [_vm._v("e커머스피칭페스타 소개")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("행사 소개")]), _c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.festa.section2.txt[0],
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section2.txt, 0, $$v);
      },
      expression: "festa.section2.txt[0]"
    }
  })], 1), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.festa.section2.txt[1],
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section2.txt, 1, $$v);
      },
      expression: "festa.section2.txt[1]"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("행사 개요")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    key: _vm.index,
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }), _c('v-col'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.$set(_vm.festa.section3.table.list, _vm.festa.section3.table.list.length, {});
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_vm._l(_vm.festa.section3.table.list, function (item, index) {
    return [_c('v-row', {
      key: index,
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1), _c('v-col', [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: item.input,
        callback: function callback($$v) {
          _vm.$set(item, "input", $$v);
        },
        expression: "item.input"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.festa.section3.table.list.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
  })], 2)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("개최 성과")])]), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.festa.section4.txt[0],
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section4.txt, 0, $$v);
      },
      expression: "festa.section4.txt[0]"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("프로그램")])]), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.festa.section5.txt[0],
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section5.txt, 0, $$v);
      },
      expression: "festa.section5.txt[0]"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("Partners "), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("이미지사이즈 : 294x96(px)")])])]), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.festa.section6.contents.frame2211.txt[0],
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section6.contents.frame2211.txt, 0, $$v);
      },
      expression: "festa.section6.contents.frame2211.txt[0]"
    }
  })], 1), _c('v-divider'), _c('v-row', {
    key: _vm.index,
    attrs: {
      "align": "center"
    }
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.$set(_vm.festa.section6.contents.frame2302.logoList, _vm.festa.section6.contents.frame2302.logoList.length, []);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1)], 1)], 1), _c('v-card-text', {
    staticClass: "py-0"
  }, [_vm._l(_vm.festa.section6.contents.frame2302.logoList, function (logo, row) {
    return [_c('v-divider', {
      key: 'dividier' + row
    }), _c('v-layout', {
      key: _vm.index,
      attrs: {
        "align": "center",
        "align-center": ""
      }
    }, [_c('v-row', {
      key: row,
      staticClass: "pr-4",
      attrs: {
        "align": "end"
      }
    }, [_vm._l(logo.length + 1, function (_, col) {
      return [col < 4 ? _c('v-col', {
        key: col,
        attrs: {
          "cols": "3"
        }
      }, [logo[col] ? [_c('v-layout', [_c('v-spacer'), _c('v-btn', {
        attrs: {
          "icon": "",
          "small": "",
          "text": ""
        },
        on: {
          "click": function click($event) {
            return logo.splice(col, 1);
          }
        }
      }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-img', {
        attrs: {
          "src": logo[col].src,
          "width": "100%",
          "height": "96",
          "contain": ""
        }
      }), _c('v-text-field', {
        attrs: {
          "placeholder": "https://",
          "hide-details": "",
          "prepend-icon": "mdi-link"
        },
        model: {
          value: _vm.festa.section6.contents.frame2302.logoList[row][col].url,
          callback: function callback($$v) {
            _vm.$set(_vm.festa.section6.contents.frame2302.logoList[row][col], "url", $$v);
          },
          expression: "festa.section6.contents.frame2302.logoList[row][col].url"
        }
      })] : [_c('v-sheet', {
        staticClass: "d-flex",
        staticStyle: {
          "cursor": "pointer",
          "border-style": "dashed",
          "border-width": "2px"
        },
        attrs: {
          "outlined": "",
          "rounded": "",
          "width": "100%",
          "height": "146"
        },
        on: {
          "click": function click($event) {
            var _vm$$refs, _vm$$refs$, _vm$$refs$$$refs, _vm$$refs$$$refs$inpu, _vm$$refs$$$refs$inpu2;
            (_vm$$refs = _vm.$refs["logo_".concat(row, "_").concat(col)]) === null || _vm$$refs === void 0 ? void 0 : (_vm$$refs$ = _vm$$refs[0]) === null || _vm$$refs$ === void 0 ? void 0 : (_vm$$refs$$$refs = _vm$$refs$.$refs) === null || _vm$$refs$$$refs === void 0 ? void 0 : (_vm$$refs$$$refs$inpu = _vm$$refs$$$refs.input) === null || _vm$$refs$$$refs$inpu === void 0 ? void 0 : (_vm$$refs$$$refs$inpu2 = _vm$$refs$$$refs$inpu.click) === null || _vm$$refs$$$refs$inpu2 === void 0 ? void 0 : _vm$$refs$$$refs$inpu2.call(_vm$$refs$$$refs$inpu);
          }
        }
      }, [_c('div', {
        staticClass: "ma-auto"
      }, [_c('v-icon', {
        attrs: {
          "left": "",
          "size": "20"
        }
      }, [_vm._v("mdi-plus")]), _c('span', [_vm._v("추가")])], 1)])], _c('v-file-input', {
        ref: "logo_".concat(row, "_").concat(col),
        refInFor: true,
        staticClass: "d-none",
        attrs: {
          "accept": ".jpg, .png"
        },
        on: {
          "change": function change(file) {
            return _vm.upload(file, row, col);
          }
        }
      })], 2) : _vm._e()];
    }), _c('v-spacer')], 2), _c('v-btn', {
      staticClass: "col-auto",
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.festa.section6.contents.frame2302.logoList.splice(row, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)];
  })], 2)], 1)], 1), _c('v-img', {
    staticClass: "mt-2",
    attrs: {
      "src": "/images/console/e-festa.png",
      "width": "450"
    }
  }), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-2",
      "elevation": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }